import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/repairers',
    name: 'repairers',
    component: () => import('@/views/restricted/repairers/RepairerLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_REPAIRER_READ_PERMISSION'],
      menuSelected: 'repairers'
    }
  },
  {
    path: '/repairers/:repairerId',
    name: 'repairerDetail',
    component: () => import('@/views/restricted/repairers/repairer/RepairerDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_REPAIRER_READ_PERMISSION'],
      menuSelected: 'repairers'
    }
  },
  {
    path: '/repairers/create',
    name: 'repairerCreate',
    component: () => import('@/views/restricted/repairers/repairer/RepairerCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_REPAIRER_CREATE_PERMISSION'],
      menuSelected: 'repairers'
    }
  },
  {
    path: '/repairers/:repairerId/edit',
    name: 'repairerUpdate',
    component: () => import('@/views/restricted/repairers/repairer/RepairerUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_REPAIRER_UPDATE_PERMISSION'],
      menuSelected: 'repairers'
    }
  },
  {
    path: '/repairers/:repairerId/repair-centers/create',
    name: 'repairCenterCreate',
    component: () =>
      import('@/views/restricted/repairers/repairer/repair-center/RepairCenterCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_REPAIRER_CREATE_PERMISSION'],
      menuSelected: 'repairers'
    }
  },
  {
    path: '/repair-centers/:repairCenterId',
    name: 'repairCenterDetail',
    component: () =>
      import(
        '@/views/restricted/repairers/repairer/repair-center/RepairCenterDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_REPAIRER_CREATE_PERMISSION'],
      menuSelected: 'repairers'
    }
  },
  {
    path: '/repair-centers/:repairCenterId/edit',
    name: 'repairCenterUpdate',
    component: () =>
      import('@/views/restricted/repairers/repairer/repair-center/RepairCenterUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_REPAIRER_UPDATE_PERMISSION'],
      menuSelected: 'repairers'
    }
  },
  {
    path: '/repair-centers/:repairCenterId/links/create',
    name: 'repairCenterLinkCreate',
    component: () =>
      import(
        '@/views/restricted/repairers/repairer/repair-center/repair-center-link/RepairCenterLinkCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_REPAIRER_UPDATE_PERMISSION'],
      menuSelected: 'repairers'
    }
  },
  {
    path: '/repair-center-links/:repairCenterLinkId',
    name: 'repairCenterLinkDetail',
    component: () =>
      import(
        '@/views/restricted/repairers/repairer/repair-center/repair-center-link/RepairCenterLinkDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_REPAIRER_CREATE_PERMISSION'],
      menuSelected: 'repairers'
    }
  },
  {
    path: '/repair-center-links/:repairCenterLinkId/edit',
    name: 'repairCenterLinkUpdate',
    component: () =>
      import(
        '@/views/restricted/repairers/repairer/repair-center/repair-center-link/RepairCenterLinkUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_REPAIRER_UPDATE_PERMISSION'],
      menuSelected: 'repairers'
    }
  }
]
